import { Button, Checkbox, Divider, Form, Input, InputNumber, Modal, Space, Table } from 'antd'
import React from 'react'
import {
    PlusOutlined,
    MinusCircleOutlined,
    CloseOutlined
} from '@ant-design/icons';

function Semafori({ isModalOpen, handleCancel, handleOk, formValues, form, loadingModal, isFromMap }) {
    const handleReferenceChange = (name, checked) => {
        if (checked) {
            // Set distance to 0 when reference is checked
            form.setFieldsValue({
                semafori: form.getFieldValue('semafori').map((item, index) =>
                    index === name ? { ...item, distanza: 0 } : item
                )
            });
        }
    };

    return (
        <Modal
            title={
                <div style={{ fontSize: '18px', fontWeight: '600' }}>
                    Configure Semafori
                </div>
            }
            open={isModalOpen}
            footer={[
                <Button
                    key="cancel"
                    onClick={handleCancel}
                    style={{
                        flex: 1,
                        height: '40px',
                        borderRadius: '20px',
                        width :"49%"
                    }}
                >
                    Annulare
                </Button>,
                <Button
                    key="submit"
                    onClick={handleOk}
                    loading={loadingModal}
                    style={{
                        flex: 1,
                        height: '40px',
                        borderRadius: '20px',
                        backgroundColor: '#A1E430',
                        borderColor: '#A1E430',
                        color: '#1a1a1a',
                        width :"49%"
                    }}
                >
                    Calcola l'offset
                </Button>,
            ]}
            onCancel={handleCancel}
            width={900}
            confirmLoading={loadingModal}
            destroyOnClose={true}
            closeIcon={<CloseOutlined />}
            bodyStyle={{ padding: '24px' }}
        >
            <Form
                form={form}
                layout="horizontal"
                initialValues={formValues}
            >
                <div style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#A1E430',
                    marginBottom: '20px'
                }}>
                    Parametri Globali
                </div>

                <div style={{
                    display: 'flex',
                    gap: '24px',
                    marginBottom: '32px',
                    justifyContent: 'space-between'
                }}>
                    <Form.Item
                        name="vel_kmh"
                        label={<span style={{ fontSize: '13px' }}>Velocity (km/h)</span>}
                        style={{ flex: 1, marginBottom: 0 }}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[{ required: true, message: 'Please input velocity!' }]}
                    >
                        <InputNumber
                            min={1}
                            style={{
                                width: '100%',
                                height: '40px',
                                borderRadius: '8px'
                            }}
                            placeholder="15"
                        />
                    </Form.Item>

                    <Form.Item
                        name="partenza_A"
                        label={<span style={{ fontSize: '13px' }}>Partenza (A)</span>}
                        style={{ flex: 1, marginBottom: 0 }}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[{ required: true, message: 'Please input start point!' }]}
                    >
                        <InputNumber
                            style={{
                                width: '100%',
                                height: '40px',
                                borderRadius: '8px'
                            }}
                            placeholder="0"
                        />
                    </Form.Item>

                    <Form.Item
                        name="anticipa_s"
                        label={<span style={{ fontSize: '13px' }}>Anticipa (s)</span>}
                        style={{ flex: 1, marginBottom: 0 }}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[{ required: true, message: 'Please input advance time!' }]}
                    >
                        <InputNumber
                            min={0}
                            style={{
                                width: '100%',
                                height: '40px',
                                borderRadius: '8px'
                            }}
                            placeholder="2"
                        />
                    </Form.Item>
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px'
                }}>
                    <div style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#A1E430'
                    }}>
                        Semafori
                    </div>
                    <Button
                        shape="circle"
                        icon={<PlusOutlined style={{color : "#fff"}} />}
                        onClick={() => {
                            const semafori = form.getFieldValue('semafori') || [];
                            form.setFieldsValue({
                                semafori: [...semafori, {
                                    nome: `S${semafori.length + 1}`,
                                    distanza: 100,
                                    durata_verde: 20,
                                    lunghezza_attraversamento: 10
                                }]
                            });
                        }}
                        style={{
                            backgroundColor: '#A1E430',
                            borderColor: '#A1E430',
                            width: '32px',
                            height: '32px'
                        }}
                    />
                </div>

                <Form.List name="semafori">
                    {(fields, { add, remove }) => (
                        <div style={{
                            background: '#f5f5f5',
                            borderRadius: '8px',
                            padding: '16px',
                            maxHeight: '300px',
                            overflowY: 'auto'
                        }}>
                            {/* Table Header */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: '1.5fr 1fr 1fr 1fr 40px',
                                gap: '16px',
                                marginBottom: '12px',
                                padding: '0 8px',
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#666'
                            }}>
                                <div>Nome*</div>
                                <div>Distanza</div>
                                <div>Durata Verde*</div>
                                <div>Lunghezza Attraversamento*</div>
                                <div></div>
                            </div>

                            {fields.map(({ key, name, ...restField }, index) => (
                                <div
                                    key={key}
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1.5fr 1fr 1fr 1fr 40px',
                                        gap: '12px',
                                        marginBottom: '12px',
                                        alignItems: 'center',
                                        padding: '8px',
                                        background: 'white',
                                        borderRadius: '6px'
                                    }}
                                >
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'nome']}
                                        style={{ marginBottom: 0 }}
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <Input
                                            placeholder="Nome"
                                            style={{
                                                height: '36px',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, 'distanza']}
                                        style={{ marginBottom: 0 }}
                                        rules={[{ required: !isFromMap, message: 'Required' }]}
                                    >
                                        <InputNumber
                                            min={0}
                                            placeholder="100"
                                            style={{
                                                width: '100%',
                                                height: '36px',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, 'durata_verde']}
                                        style={{ marginBottom: 0 }}
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <InputNumber
                                            min={0}
                                            placeholder="20"
                                            style={{
                                                width: '100%',
                                                height: '36px',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, 'lunghezza_attraversamento']}
                                        style={{ marginBottom: 0 }}
                                    >
                                        <InputNumber
                                            min={0}
                                            placeholder="10"
                                            style={{
                                                width: '100%',
                                                height: '36px',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Item>

                                    <Button
                                        type="text"
                                        danger
                                        icon={<MinusCircleOutlined />}
                                        onClick={() => remove(name)}
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </Form.List>

                {isFromMap && (
                    <div style={{
                        marginTop: '16px',
                        fontSize: '12px',
                        color: '#888',
                        fontStyle: 'italic'
                    }}>
                        Se vuoi calcolare la distanza automaticamente, lascia il campo della distanza vuoto.
                    </div>
                )}
            </Form>
        </Modal>
    )
}

export default Semafori